import { render } from "./NewStudentRow.vue?vue&type=template&id=bd85924a&scoped=true"
import script from "./NewStudentRow.vue?vue&type=script&lang=js"
export * from "./NewStudentRow.vue?vue&type=script&lang=js"

import "./NewStudentRow.vue?vue&type=style&index=0&id=bd85924a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd85924a"]])

export default __exports__